import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesSource = (params: any) => {
  return activitiesApi.get('source', { params });
};